import { useRef } from "react"
import { motion } from "framer-motion"
import styled from "@emotion/styled"

import { useConsole } from "contexts/Console"
import { usePage } from "contexts/Page"

import { fullGrid } from "css/grid"
import getMediaQuery from "css/breakpoints"

import useParallax from "hooks/useParallax"

import Image from "components/media/ImageCLD"
import WatermarkOyster from "components/oyster-story-logo/Watermark"
import { cssVars } from "components/nav-v2/Wrapper"
import ReadingInfo from "components/reading-info/ReadingInfo"
import PageHeading from "./PageHeading"
import CTATxt from "./CTATxt"

const Header = styled.header`
  position: relative;
  justify-content: center;

  overflow: hidden;

  z-index: 0;

  ${fullGrid};

  &.multirows {
    grid-template-rows: min-content min-content 40px;

    ${getMediaQuery("m")} {
      grid-template-rows: min-content min-content 60px;
    }

    & hgroup {
      padding-block-start: 0;
      align-self: center;
      border: solid 3px red;
    }
  }
  &.coverImage {
    hgroup {
      padding-block-start: 0;
      align-self: center;
    }
  }

  & > svg {
    position: absolute;
    grid-column: doc;
    grid-row: 1;
    height: calc(100% - 4vh);
    margin-inline-start: 2vh;
    align-self: center;
  }
`

const Figure = styled(motion.figure)`
  display: block;
  width: 100%;
  grid-column: doc;
  grid-row: 1 / -1;

  z-index: -1;
  background-color: black;

  & picture {
    display: flex;
    height: 100%;
  }

  & img {
    width: 100%;
    height: 100%;
    object-position: center;
    object-fit: cover;
    transform: translateY(var(--ypos)) scale(1.2);
  }
`

export default function CoverImage({ heading, heading_gradient, image_cld: image, text, video_amp_cta, className, watermark }) {
  const console = useConsole()
  const { is_reading_info, reading_info } = usePage()

  const ref = useRef()

  const y = useParallax(ref)

  const cl = text?.length && !text?.[0]?.link_404 ? " multirows" : ""

  return (
    <>
      <Header ref={ref} className={`${className}${cl} coverImage`}>
        <PageHeading
          animate
          heading={heading}
          heading_gradient={heading_gradient}
          link={text?.[0]?.link_404}
          video_amp={video_amp_cta?.length ? video_amp_cta[0].video_player_cld : null}
        />
        <Figure style={{ "--ypos": y }}>
          <Image {...image} sizes='100vw' animate />
        </Figure>
        {watermark ? <WatermarkOyster /> : null}
        {text?.length && !text?.[0]?.link_404 ? <CTATxt blocks={text} /> : null}
      </Header>
      {is_reading_info ? <ReadingInfo {...reading_info} /> : null}
    </>
  )
}
